
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const PricingSection = () => {
  const navigate = useNavigate();
  
  // Define price IDs for consistency across the application
  const priceIds = {
    monthly: "price_1QvOaiG3RRUf49cQgmkP8MtT",
    yearly: "price_1QvObYG3RRUf49cQp6XPRkNN",
    lifetime: "price_1QvOcGG3RRUf49cQlU0O22em"
  };
  
  return (
    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
      <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow text-center">
        <h3 className="text-xl font-semibold mb-4">Monthly</h3>
        <p className="text-4xl font-bold mb-6">$9.99<span className="text-lg text-gray-500">/mo</span></p>
        <p className="text-sm text-gray-500 mb-6">Billed monthly at $9.99</p>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => navigate("/signup", { state: { plan: "monthly", priceId: priceIds.monthly } })}
        >
          Get Started
        </Button>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow text-center relative">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-max">
          <span className="bg-primary text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">
            Most Popular
          </span>
        </div>
        <h3 className="text-xl font-semibold mb-4">Yearly</h3>
        <p className="text-4xl font-bold mb-6">$4.99<span className="text-lg text-gray-500">/mo</span></p>
        <p className="text-sm text-gray-500 mb-6">Billed annually at $59.88</p>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => navigate("/signup", { state: { plan: "yearly", priceId: priceIds.yearly } })}
        >
          Get Started
        </Button>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow text-center">
        <h3 className="text-xl font-semibold mb-4">Lifetime</h3>
        <p className="text-4xl font-bold mb-6">$199.99<span className="text-lg text-gray-500">/once</span></p>
        <p className="text-sm text-gray-500 mb-6">Billed once at $199.99</p>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => navigate("/signup", { state: { plan: "lifetime", priceId: priceIds.lifetime } })}
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};
